import ListRfqQuoteContents from '../../../../../../client/src/rfq/src/viewmodel/ListRfqQuoteContentsViewModel';
import { DesBaseRfqQuote } from '../utils/des-base-rfq-quote';

export default class DesListRfqQuoteContents extends DesBaseRfqQuote {

    constructor() {
        console.log('DesRfqQuoteContents invoked');
        super(ListRfqQuoteContents);
    }

    static get observedAttributes() {
        return [ ...DesBaseRfqQuote.observedAttributes];
    }
}
if (!window.customElements.get('des-list-rfq-quote-contents')) {
    window.customElements.define('des-list-rfq-quote-contents', DesListRfqQuoteContents);
}
